module.exports = __webpack_public_path__ + "assets/-.34f5ec24.svg";